import { PhotoContestAdsAppView } from '@smithsonian/js/ads/views/PhotoContestAdsAppView';
import $ from 'jquery';

$(function () {
    // setup PhotoContestAdsAppView with streamable ads
    var adApp = new PhotoContestAdsAppView({
        disableAd: [
            'defaultPhotoContestTop',
            'defaultPhotoContestMiddle',
            'defaultPhotoContestBottom',
            'defaultPhotoContestStream',
        ],
    });
});
